import { render, staticRenderFns } from "./dialog-fee-show.vue?vue&type=template&id=4dd810bc&scoped=true&"
import script from "./dialog-fee-show.vue?vue&type=script&lang=js&"
export * from "./dialog-fee-show.vue?vue&type=script&lang=js&"
import style0 from "./dialog-fee-show.vue?vue&type=style&index=0&id=4dd810bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd810bc",
  null
  
)

export default component.exports